// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__33k2e","title":"Info_title__13AuN","links":"Info_links__2FcLy","link":"Info_link__5M_vp","logo":"Info_logo__3-iX-"};